import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';
import EbscoPagination from '@ebsco-ui/pagination';

import { getLimitedPageCount } from '@app/utils';
import { paginationMessages } from '@app/translations';
import { ShapeWithClassName } from '@app/constants';

import './Pagination.scss';

const cnBem = createBemBlockBuilder(['pagination']);

interface PaginationProps {
  pageNumber: number;
  totalRecords: number;
  recordsPerPage: number;
  mode?: 'auto' | 'always';
  onPageChange: (pageNumber: number) => void;
}

export const Pagination: FC<ShapeWithClassName<PaginationProps>> = ({
  pageNumber = 0,
  totalRecords,
  recordsPerPage,
  className,
  mode = 'always',
  onPageChange,
}) => {
  const { $t } = useIntl();

  const pageCount = getLimitedPageCount(totalRecords, recordsPerPage);

  if (mode === 'always' || (mode === 'auto' && totalRecords > recordsPerPage)) {
    return (
      <EbscoPagination
        activePage={pageNumber}
        count={pageCount}
        previousPageLabel={$t(paginationMessages.previousPage)}
        nextPageLabel={$t(paginationMessages.nextPage)}
        paginationAriaLabel={$t(paginationMessages.pagination)}
        className={cn(className, cnBem())}
        pageAriaLabel={page =>
          page === pageNumber
            ? $t(paginationMessages.currentPage, {
                page,
              })
            : $t(paginationMessages.page, {
                pageNumber: page,
              })
        }
        onSelect={onPageChange}
      />
    );
  }

  return null;
};
